<template>
  <div class="bg1" ref="setH">
    <div class="manageBox">
      <div class="searchBox">
        <el-form ref="form" :model="search" label-width="120px" size="small">
          <el-form-item label="学校：" v-if="userModule.roles.map((el) => el.roleCode).includes('AreaManager')">
            <el-select v-model="search.schoolId" placeholder="选择学校" clearable>
              <el-option v-for="item in conditions.xuexiaoList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="学段："
            ><el-select
              v-model="search.sectionId"
              placeholder="选择学段"
              size="small"
              clearable
            >
              <el-option
                v-for="item in conditions.xueduanList"
                :key="item.node"
                :label="item.text"
                :value="item.node"
              ></el-option> </el-select
          ></el-form-item> -->
          <el-form-item label="年级：">
            <el-select v-model="search.gradeId" placeholder="选择年级" size="small" clearable>
              <el-option v-for="item in conditions.nianjiList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学科：">
            <el-select v-model="search.subjectId" placeholder="选择学科" size="small" clearable>
              <el-option v-for="item in conditions.xuekeList" :key="item.node" :label="item.text" :value="item.node"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纸张类型：">
            <el-select v-model="search.paperType" placeholder="选择纸张类型" size="small" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in conditions.paperTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-date-picker v-model="search.startTime" :picker-options="pickerOptionsStart" size="small" value-format="yyyy-MM-dd" type="date"
                            style="width: 150px" placeholder="选择开始日期">
            </el-date-picker>
            <font style="padding: 0 10px">至</font>
            <el-date-picker v-model="search.endTime" :picker-options="pickerOptionsEnd" size="small" value-format="yyyy-MM-dd" type="date" style="width: 150px"
                            placeholder="选择结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataList" size="small">查询</el-button>
            <el-button type="primary" @click="daochu" size="small">导出</el-button>
            <el-button @click="clear" size="small">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contentBox">
        <div style="
            background-color: #edf5ff;
            line-height: 40px;
            float: right;
            padding: 0 15px;
            color: #444;
          ">
          合计 | 打印份数<span style="color: #0096ff; padding: 0 4px; font-weight: bold">{{ printNumAndPage.printNumber }}</span>，打印纸张数<span
                style="color: #0096ff; padding: 0 4px; font-weight: bold">{{
            printNumAndPage.filePage
          }}</span>，单面纸张数<span style="color: #0096ff; padding: 0 4px; font-weight: bold">{{
            printNumAndPage.singlePrintNumber
          }}</span>，双面纸张数<span style="color: #0096ff; padding: 0 4px; font-weight: bold">{{
            printNumAndPage.doublePrintNumber
          }}</span>
        </div>
        <el-table stripe :data="tableData" style="width: 100%" @sort-change="sort">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="schoolName" label="校区"></el-table-column>
          <el-table-column prop="gradeName" label="年级"></el-table-column>
          <el-table-column prop="subjectName" label="学科"></el-table-column>
          <el-table-column prop="paperTypeName" label="纸张类型"></el-table-column>
          <el-table-column prop="printTypeName" label="打印类型"></el-table-column>
          <el-table-column prop="printNumber" sortable="custom" label="打印份数"></el-table-column>
          <el-table-column prop="filePage" sortable="custom" label="打印纸张数"></el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]" :page-size="100"
                         layout="total, sizes, prev, pager, next, jumper" :total="pages.pageAll">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import Axios from "axios";
import role from "../../mixins/role";
import qs from "qs";
export default {
  name: "statisticsSchool",
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.search.endTime) {
            return time.getTime() > new Date(this.search.endTime).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.search.startTime) {
            return (
              time.getTime() <
              new Date(this.search.startTime).getTime() - 86400000
            );
          }
        },
      },
      ccc: "按校区统计",
      search: {
        subjectId: "",
        startTime: "",
        endTime: "",
        page: 1,
        size: 10,
        sectionId: "",
        gradeId: "",
        paperType: "",
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      conditions: {
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        xuexiaoList: [],
        paperTypeList: [],
      },
      tabH: 0,
      printNumAndPage: {
        filePage: 0,
        printNumber: 0,
        singlePrintNumber: 0,
        doublePrintNumber: 0,
      },
    };
  },
  mixins: [role],
  watch: {
    "search.schoolId": {
      handler(v) {
        if (v) {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.getNianJi();
        } else {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
        }
      },
    },
    "search.gradeId": {
      handler(v) {
        if (v) {
          this.search.subjectId = "";
          this.conditions.xuekeList = [];
          this.getXueKe();
        } else {
          this.search.subjectId = "";
          this.conditions.xuekeList = [];
        }
      },
    },
  },
  mounted() {},
  methods: {
    init() {
      if (
        !this.userModule.roles.map((el) => el.roleCode).includes("AreaManager")
      ) {
        this.search.schoolId = this.userModule.schoolId;
        this.getNianJi();
      }

      this.$nextTick(() => {
        this.tabH = this.$refs.setH.clientHeight - 160;
      });
      this.getXueDuan();
      this.getDataList();
      this.getSchoolList();
      this.getPaperType();
    },
    getPaperType() {
      this.$ajax.post("/common/load/paper/type").then((res) => {
        this.conditions.paperTypeList = res;
        this.search.paperType = "";
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else if (index === 1) {
          sums[index] = "";
          return;
        } else if (index === 2) {
          sums[index] = "";
          return;
        } else if (index === 3) {
          sums[index] = "";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    sort({ column, prop, order }) {
      let o =
        order == "ascending" ? "asc" : order == "descending" ? "desc" : "asc";
      this.search.sortString = prop + " " + o;
      this.getDataList();
    },
    // 获取学校列表
    getSchoolList() {
      let urlLink = `/common/load/group/school`;
      let param = {};
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取学校", res);
        this.conditions.xuexiaoList = res;
      });
    },
    //清空查询条件
    clear() {
      this.search.sectionId = "";
      this.search.gradeId = "";
      this.search.subjectId = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.schoolId = "";
      this.search.paperType = "";
    },
    // 获取学段
    getXueDuan() {
      let urlLink = `/common/catalog/load/section`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取学段", res);
        this.conditions.xueduanList = res;
      });
    },
    // 获取年级
    getNianJi() {
      let urlLink = `/common/load/school/grade`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取年级", res);
        this.conditions.nianjiList = res;
      });
    },
    // 获取学科
    getXueKe() {
      let urlLink = `/common/catalog/load/grade/subject`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取学科", res);
        this.conditions.xuekeList = res;
      });
    },
    // 获取统计列表
    getDataList() {
      let urlLink = `/server/statistics/print/getStatisticsPrint`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
      this.$ajax
        .post("/server/statistics/print/getPrintNumAndPage", param)
        .then((res) => {
          this.printNumAndPage = res
            ? res
            : {
                filePage: 0,
                printNumber: 0,
                singlePrintNumber: 0,
                doublePrintNumber: 0,
              };
        });
    },
    // 分页页码变动
    handleSizeChange(v) {
      this.search.size = v;
      this.search.page = 1;
      this.getDataList();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getDataList();
    },
    // 导出
    daochu() {
      let param = this.search;
      var requestUrl = "/server/statistics/print/export";
      Axios({
        method: "post",
        url: requestUrl,
        data: qs.stringify(param),
        responseType: "blob",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((res) => {
          fileDownload(res.data, "打印统计.xlsx");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/statistics/print.vue